var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticClass: "chart-card bottom-card", attrs: { shadow: "hover" } },
    [
      _c(
        "div",
        {
          staticClass: "card-header",
          attrs: { slot: "header" },
          slot: "header",
        },
        [
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.title ||
                  "人效分析 Monitoramento da eficiência de coleta de estado"
              )
            ),
          ]),
          _c("img", {
            staticClass: "export-btn",
            attrs: { src: _vm.exportIcon, alt: "导出" },
            on: { click: _vm.handleExport },
          }),
        ]
      ),
      _c("div", { staticClass: "personnel-stats" }, [
        _c("div", { staticClass: "stat-row" }, [
          _c("div", { staticClass: "stat-box light-green" }, [
            _c("div", { staticClass: "stat-corner" }, [
              _c("div", { staticClass: "icon-bg" }, [
                _c("img", {
                  staticClass: "corner-icon",
                  attrs: { src: _vm.icon1, alt: "icon" },
                }),
              ]),
            ]),
            _c("div", { staticClass: "stat-label" }, [
              _vm._v("上岗人数 Numero de pessoas no posto"),
            ]),
            _c("div", { staticClass: "stat-val" }, [
              _vm._v(_vm._s(_vm.data.staffCount || 0)),
            ]),
          ]),
          _c("div", { staticClass: "stat-box light-blue" }, [
            _c("div", { staticClass: "stat-corner" }, [
              _c("div", { staticClass: "icon-bg" }, [
                _c("img", {
                  staticClass: "corner-icon",
                  attrs: { src: _vm.icon2, alt: "icon" },
                }),
              ]),
            ]),
            _c("div", { staticClass: "stat-label" }, [
              _vm._v("揽收票数 Numero de votos coletados"),
            ]),
            _c("div", { staticClass: "stat-val" }, [
              _vm._v(_vm._s(_vm.data.collectCnt || 0)),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "stat-row" }, [
          _c("div", { staticClass: "stat-box light-yellow" }, [
            _c("div", { staticClass: "stat-corner" }, [
              _c("div", { staticClass: "icon-bg" }, [
                _c("img", {
                  staticClass: "corner-icon",
                  attrs: { src: _vm.icon3, alt: "icon" },
                }),
              ]),
            ]),
            _c("div", { staticClass: "stat-label" }, [
              _vm._v("平均人效 Numero de pessoas no posto"),
            ]),
            _c("div", { staticClass: "stat-val" }, [
              _vm._v(_vm._s(_vm.averageEfficiency)),
            ]),
          ]),
          _c("div", { staticClass: "stat-box transparent" }, [
            _c("div", { staticClass: "cache-time" }, [
              _vm._v("缓存: " + _vm._s(_vm.cacheTime)),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }